// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n#i4goFrame[data-v-11305895] {\n    visibility: hidden;\n}\n.disabled-image[data-v-11305895] {\n    opacity: 0.5;\n}\n#nspay-apple-pay[data-v-11305895] {\n    margin-top: 12px;\n}\n#apple-pay-logo[data-v-11305895] {\n    min-height: 30px;\n}\n.apple-pay-button[data-v-11305895] {\n    padding: 0;\n}\n.no-apple-pay[data-v-11305895] {\n    visibility: hidden;\n}\n\n", ""]);
// Exports
module.exports = exports;
